import { render, staticRenderFns } from "./ViewResetPassword.vue?vue&type=template&id=49501002&"
import script from "./ViewResetPassword.vue?vue&type=script&lang=js&"
export * from "./ViewResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ViewResetPassword.vue?vue&type=style&index=0&id=49501002&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports